import { render } from "./TOC.vue?vue&type=template&id=443fca0d"
import script from "./TOC.vue?vue&type=script&lang=js"
export * from "./TOC.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__